import React from 'react';
import type {TableButton, TableRowType} from 'shared/types';
import {isButtonHidden} from './helpers';
import {JobCardPrintAction} from './JobCardPrintAction';
import {JobCardPromptButton} from './JobCardPromptButton';

export const JobCardActions = ({
    buttons,
    row,
}: {
    buttons: TableButton[];
    row: TableRowType;
}) => {
    const visibleButtons = buttons.filter(
        (button) => !isButtonHidden(button, row)
    );

    if (!visibleButtons.length) {
        return null;
    }

    return (
        <div className="job-card-actions">
            {visibleButtons.map((button) => {
                if (button.dropdown && button.dropdown.length) {
                    return (
                        <JobCardPrintAction
                            key={button.title}
                            button={button}
                            row={row}
                        />
                    );
                }

                if (button.as) {
                    const Component = button.as;

                    return <Component row={row} key={button.title} />;
                }

                return (
                    <JobCardPromptButton
                        key={button.title}
                        button={button}
                        row={row}
                    />
                );
            })}
        </div>
    );
};
